<template>
  <v-menu top v-model="menuOpened" :offset-y="true" transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn :class="buttonClasses" icon v-on="on" :disabled="disabled">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-subheader v-if="menuSubheader">{{menuSubheader}}</v-subheader>
      <v-list-item v-for="(action, key) in actions" :key="key" @click="onActionClicked(action)" :class="action.classes">
        <v-list-item-icon v-if="action.icon">
          <v-icon>{{action.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          {{action.label}}
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ActionsButton",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Object,
      required: true
    },
    entity: {
      type: Object,
      required: true
    },
    buttonClasses: {
      type: String,
      required: false
    },
    menuSubheader: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      menuOpened: false
    };
  },
  methods: {
    onActionClicked: function(action) {
      // console.log("clicked", action);
      action.action(this.entity);
    }
  }
};
</script>